import fr from './fr.json';
import en from './en.json';
import de from './de.json';
import es from './es.json';
import sl from './sl.json';
import lv from './lv.json';
import it from './it.json';
import sv from './sv.json';
import hu from './hu.json';
import uk from './uk.json';

export const dictionaryList = { en, fr, de, es, sl, lv, it, sv, hu, uk };

export const languageOptions = {
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  sl: 'Slovenščina',
  lv: 'Latviešu',
  it: 'Italiano',
  sv: 'Svenska',
  hu: 'Magyar',
  uk: 'Українська'
};
